module.exports = new __parcel__URL__("three-active-avatars.e2794962.svg").toString();